import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, CssBaseline } from '@mui/material';
import { useDashboardContext } from 'context/dashboard.context';
import Topnav from 'layout/Topnav';
import Sidenav from 'layout/Sidenav/Sidenav';
import CustomSnackbar from 'components/Snackbar/CustomSnackbar';

const ContentContainer = styled(Box)`
  padding-top: 4rem;
  width: calc(100% - 15rem);
  background-color: ${(props) => props.theme.palette.background.default};
`;

interface LayoutProps {
  children: JSX.Element | JSX.Element[];
}

type Props = LayoutProps;

const Layout = ({ children }: Props): JSX.Element => {
  const { md, drawerWidth } = useDashboardContext();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <CustomSnackbar />
      <Topnav />
      <Sidenav />
      <ContentContainer
        sx={{
          marginLeft: md ? `${drawerWidth}rem` : '0',
          width: md ? 'calc(100% - 15rem)' : '100%',
        }}
      >
        {children}
      </ContentContainer>
    </Box>
  );
};

export default Layout;
